import axios from 'axios'

// Suporte a runtime env (Docker) e build-time env (Vite)
const runtimeEnv = (window as any).env || {}
const API_URL = runtimeEnv.VITE_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:3000/api'

console.log('[API] Using API_URL:', API_URL)

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('kardapio-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    console.log('[API] Request:', config.method?.toUpperCase(), config.url)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('[API] Response:', response.status, response.config.url)
    return response
  },
  (error) => {
    console.error('[API] Error:', error.response?.status, error.response?.config?.url, error.message)
    if (error.response?.status === 401) {
      localStorage.removeItem('kardapio-token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
